<template>
    <div>
        <!--<h3 class="h6 block-title ps-0 mb-5">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    opacity="0.5"
                    d="M2 12C2 7.286 2 4.929 3.464 3.464C4.93 2 7.286 2 12 2C16.714 2 19.071 2 20.535 3.464C22 4.93 22 7.286 22 12C22 16.714 22 19.071 20.535 20.535C19.072 22 16.714 22 12 22C7.286 22 4.929 22 3.464 20.535C2 19.072 2 16.714 2 12Z"
                    fill="#F5C1AB"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.914 11.25H2V12.75H10.163C9.99399 13.4618 9.58981 14.0958 9.01583 14.5495C8.44185 15.0032 7.73162 15.25 7 15.25C6.80109 15.25 6.61032 15.329 6.46967 15.4697C6.32902 15.6103 6.25 15.8011 6.25 16C6.25 16.1989 6.32902 16.3897 6.46967 16.5303C6.61032 16.671 6.80109 16.75 7 16.75C7.88241 16.7502 8.74744 16.5047 9.49812 16.0409C10.2488 15.577 10.8554 14.9133 11.25 14.124V22H12.75V14.124C13.1446 14.9133 13.7512 15.577 14.5019 16.0409C15.2526 16.5047 16.1176 16.7502 17 16.75C17.1989 16.75 17.3897 16.671 17.5303 16.5303C17.671 16.3897 17.75 16.1989 17.75 16C17.75 15.8011 17.671 15.6103 17.5303 15.4697C17.3897 15.329 17.1989 15.25 17 15.25C16.2684 15.25 15.5581 15.0032 14.9842 14.5495C14.4102 14.0958 14.006 13.4618 13.837 12.75H22V11.25H17.087C17.437 10.812 17.7 10.295 17.843 9.723C18.381 7.57 16.43 5.62 14.277 6.158C13.7195 6.29702 13.1986 6.55491 12.75 6.914V2H11.25V6.914C10.8014 6.55491 10.2805 6.29702 9.723 6.158C7.57 5.62 5.62 7.57 6.158 9.723C6.301 10.295 6.563 10.812 6.914 11.25ZM11.25 11.25H9.997C9.44679 11.2415 8.91479 11.0516 8.48368 10.7096C8.05256 10.3676 7.74648 9.89284 7.613 9.359C7.55269 9.1177 7.55591 8.86489 7.62234 8.6252C7.68877 8.38552 7.81616 8.16712 7.99208 7.9913C8.16801 7.81547 8.38647 7.68822 8.6262 7.62192C8.86592 7.55562 9.11873 7.55255 9.36 7.613C9.89384 7.74648 10.3686 8.05256 10.7106 8.48368C11.0526 8.91479 11.2425 9.44679 11.251 9.997V11.25H11.25ZM14.003 11.25H12.75V10.005C12.7567 9.45341 12.9459 8.91958 13.288 8.48684C13.6301 8.05411 14.1059 7.74683 14.641 7.613C14.8822 7.55276 15.1349 7.556 15.3745 7.62239C15.614 7.68878 15.8324 7.81607 16.0081 7.99186C16.1839 8.16765 16.3112 8.38596 16.3776 8.62554C16.444 8.86512 16.4472 9.1178 16.387 9.359C16.2535 9.89284 15.9474 10.3676 15.5163 10.7096C15.0852 11.0516 14.5532 11.2415 14.003 11.25Z"
                    fill="#F5C1AB"
                />
            </svg>
            Bons cadeau
        </h3>-->
        <div class="justify-content-between align-content-center rounded mt-2">
            <input type="hidden" name="voucherArray" :value="JSON.stringify(vouchersUsed)" />
            <label class="form-label" for="voucher_code">{{ current_name }}</label>
            <div class="d-flex flex-column justify-content-between">
                <div class="d-flex gap-3 bnd-resp">
                    <input
                        type="text"
                        name="voucher_code"
                        id="voucher_code"
                        ref="voucherCode"
                        :placeholder="$t('common.please_fill')"
                        class="form-control mb-3 height48"
                    />
                    <button
                        type="button"
                        class="btn fs-6 btn-dark rounded-8 height48 px-5 fw-medium"
                        v-on:click="handleVoucherCodeSearch()"
                    >
                        {{ $t('checkout.payment.apply') }}
                    </button>
                </div>
                <div v-if="invalidVoucher && error != null" class="text-danger mb-3">{{ error }}</div>
                <div v-for="(item, i) in vouchersUsed" :key="i">
                    <div style="display: flex; flex-direction: row; justify-content: space-between">
                        <p class="text-green fw-medium fs-sm mb-3">
                            - {{ getVoucherTypeLabel(item.type) }} N° ({{ item.code }}) : {{ item.available_amount
                            }}{{ $symbolCurrency }}
                            {{ $t('checkout.voucher.valid_until') }}
                            {{ parseDate(item.date_end) }}
                        </p>
                        <button type="button" @click="deleteBC(item)">
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M3.5 6H21.5"
                                    stroke="#94A3B8"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M19.5 6V20C19.5 21 18.5 22 17.5 22H7.5C6.5 22 5.5 21 5.5 20V6"
                                    stroke="#94A3B8"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M8.5 6V4C8.5 3 9.5 2 10.5 2H14.5C15.5 2 16.5 3 16.5 4V6"
                                    stroke="#94A3B8"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M10.5 11V17"
                                    stroke="#94A3B8"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M14.5 11V17"
                                    stroke="#94A3B8"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
                <p v-if="voucherTotal > 0" class="ppv2-text-black fw-normal fs-sm mb-1">
                    {{
                        $t('checkout.voucher.total_available', {
                            type: getVoucherTypeLabel(type),
                            amount: voucherTotal,
                        })
                    }}
                </p>
                <div v-if="voucherBlocked" class="text-warning mb-1">
                    {{ $t('checkout.voucher.blocked', { type: getVoucherTypeLabel(type) }) }}
                </div>
                <div v-if="voucherAmountNull" class="text-warning mb-1">
                    {{ $t('checkout.voucher.already_used', { type: getVoucherTypeLabel(type) }) }}
                </div>
            </div>
        </div>
        <div v-if="voucherArray.length > 0" class="block px-0 pt-0">
            <!--<div class="block-header">
                <h6 class="block-title mb-0">Montant à utiliser</h6>
            </div>-->
            <div class="block-content p-0">
                <ul v-for="(item, i) in vouchersUsed" :key="i" class="p-0 mb-0">
                    <li class="d-flex row">
                        <span class="d-flex align-items-center px-0 ppv2-text-black fw-normal fs-sm col-4 pb-0">
                            - {{ current_name }} N° ({{ item.code }})
                        </span>
                        <div class="col-8 pe-0 pb-0">
                            <div class="d-flex align-items-center">
                                <div class="input-group">
                                    <input
                                        type="number"
                                        class="form-control input-desg"
                                        min="0"
                                        :max="c_remainPrice < item.available_amount ? c_remainPrice : item.available_amount"
                                        v-model="item.amount"
                                        :disabled="item.type === 'undated_ticket'"
                                    />
                                    <span class="span-desg">/ {{ item.available_amount }}{{ $symbolCurrency }}</span>
                                </div>
                                <!--<span class="w-100 ms-2">/ {{ item.available_amount }}{{$symbolCurrency}}</span>-->
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import ApiManager from '../../Calendar/_core/ApiManager'
import { get, sync } from 'vuex-pathify'

export default {
    // current_name = libellé traduit (affichage seul) ; voucher_type = clé stable
    // ('voucher' | 'isUndatedTicket') utilisée par le backend pour la comparaison.
    props: ['current_name', 'voucher_type'],
    data: () => ({
        // voucher
        voucher: null,
        voucherArray: [],
        voucherTotal: 0,
        voucherEntered: false,
        voucherApplied: false,
        voucherBlocked: false,
        invalidVoucher: false,
        voucherAmountNull: false,
        error: null,
        vouchersUsed: [],
        type: '',
    }),
    mounted() {
        this.getselectedVoucherItems()
    },
    computed: {
        ...sync('overlay@data', {
            c_payments: 'payments',
            c_voucherUsed: 'voucherUsed',
        }),
        ...get('overlay@data', {
            c_remainPrice: 'remainPrice',
        }),
    },
    watch: {
        voucherArray(newVal) {
            newVal.forEach((el) => {
                if (!this.vouchersUsed.find((v) => v.code == el.code)) {
                    let type = el.items[0]?.item_type == 'App\\Models\\Prestation\\Prestation' ? 'undated_ticket' : 'vouchers'
                    this.vouchersUsed.push({
                        id: el.id,
                        code: el.code,
                        amount:
                            type == 'undated_ticket' ? el.available_amount : Math.min(this.c_remainPrice, el.available_amount),
                        available_amount: el.available_amount,
                        date_end: el.date_end,
                        type: type,
                    })
                }
            })
        },
        vouchersUsed: {
            handler(newVal) {
                if (newVal.find((el) => el.amount == '')) {
                    newVal[newVal.findIndex((el) => el.amount == '')].amount = 1
                }
                this.c_voucherUsed = this.vouchersUsed
                this.$emit(
                    'vouchers-update',
                    newVal.map((x) => parseFloat(x.amount, 2))
                )
            },
            deep: true,
        },
    },
    methods: {
        async getselectedVoucherItems() {
            await ApiManager.getselectedVoucherItems(0).then((res) => {
                if (res.data != 0) {
                    res.data.forEach((element) => {
                        this.handleVoucherCodeSearch()
                    })
                }
            })
        },
        handleVoucherCodeSearch() {
            // this.$refs.voucherCode.value = 7755872296
            // console.log('rzea')
            if (this.$refs.voucherCode.value !== '') {
                const params = new URLSearchParams(window.location.search)
                axios
                    .get(`/back-office/voucher/check-code`, {
                        params: {
                            code: this.$refs.voucherCode.value,
                            type: this.current_name,
                            voucher_type: this.voucher_type,
                            orderId: params.get('order'),
                        },
                    })
                    .then((res) => {
                        // Si le code est invalide
                        if (!res.data || Object.keys(res.data).length === 0) {
                            this.voucherApplied = false
                            this.voucher = null
                            this.voucherAmountNull = false
                            this.invalidVoucher = true
                        } else {
                            if (typeof res.data === 'string') {
                                this.invalidVoucher = true
                                this.voucherApplied = false
                                this.voucher = null
                                this.voucherAmountNull = false
                                this.error = res.data
                            } else {
                                if (
                                    !this.voucherArray
                                        .map((e) => {
                                            if (e.id == res.data.id) return false
                                        })
                                        .includes(false)
                                ) {
                                    this.voucherArray.push(res.data)
                                    this.voucherTotal += res.data.available_amount
                                    document.getElementById('voucher_code').value = ''
                                }
                                this.voucher = res.data
                                this.type =
                                    this.voucher?.items[0]?.item_type == 'App\\Models\\Prestation\\Prestation'
                                        ? 'undated_ticket'
                                        : 'vouchers'
                                if (this.voucher.is_blocked) {
                                    this.voucherBlocked = true
                                    this.invalidVoucher = false
                                    this.voucherApplied = false
                                    this.voucherAmountNull = false
                                } else if (this.voucher.available_amount == 0) {
                                    this.voucherBlocked = false
                                    this.invalidVoucher = false
                                    this.voucherApplied = false
                                    this.voucherAmountNull = true
                                } else {
                                    this.invalidVoucher = false
                                    this.voucherApplied = true
                                    this.voucherAmountNull = false
                                    this.voucherBlocked = false
                                }
                            }
                        }
                    })
                    .catch((err) => {
                        this.invalidVoucher = true
                        this.voucherApplied = false
                        this.voucher = null
                        this.voucherAmountNull = false
                        this.error = err.response.data['message']
                    })
            } else {
                this.currentVoucher = null
            }
        },
        parseDate(date) {
            return moment(date).locale(this.$i18n.locale).format('DD/MM/YYYY')
        },
        getVoucherTypeLabel(type) {
            return type ? this.$t(`checkout.categories.${type}`) : ''
        },

        deleteBC(e) {
            const isLargeNumber = (element) => element.id == e.id
            const voucherToDelete = this.voucherArray.find(isLargeNumber)
            const index = this.voucherArray.findIndex(isLargeNumber)
            if (index > -1) {
                this.voucherArray.splice(index, 1)
                this.voucherTotal -= e.available_amount
                this.vouchersUsed.splice(
                    this.vouchersUsed.findIndex((v) => v.code == voucherToDelete.code),
                    1
                )
            }
        },
    },
}
</script>

<style scoped>
.input-desg {
    min-width: 145px !important;
    height: 40px;
    border-radius: 8px 0px 0px 8px;
    border-right: none;
    font-size: 16px;
    font-weight: 400;
    padding: 8px 16px 8px 16px !important;
    flex: unset !important;
}
.span-desg {
    background-color: #021832;
    height: 40px;
    min-width: 145px;
    border-radius: 0px 8px 8px 0px;
    color: #fff !important;
    text-align: center !important;
    font-weight: 500 !important;
    padding: 10px 24px 10px 24px !important;
}
</style>
